import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { BrowserRouter } from 'react-router-dom';
import { MbmProvider } from '@amzn/react-arb-tools';
import { INITIAL_LOCALE, createMbmOptions } from './i18n/index';
import React from 'react';
import { AuthProvider } from 'react-oidc-context';
import { createAuthConfig } from './config/authConfig';
import './index.css';
import { LANGUAGES } from './Utils/CountryConstant';

const authConfig = createAuthConfig();

const AppWithAuth = authConfig ? (
  <AuthProvider {...authConfig}>
    <App />
  </AuthProvider>
) : (
  <App />
);

const searchParams = new URLSearchParams(window.location.search);
const localeParam = searchParams.get('locale')?.replace('_', '-');

ReactDOM.render(
  <MbmProvider
    {...(localeParam && localeParam in LANGUAGES ? createMbmOptions(localeParam) : createMbmOptions(INITIAL_LOCALE))}
  >
    <StencilProvider locale={localeParam && localeParam in LANGUAGES ? localeParam : INITIAL_LOCALE}>
      <BrowserRouter>
        <Suspense fallback="Loading...">
          <React.StrictMode>{AppWithAuth}</React.StrictMode>
        </Suspense>
      </BrowserRouter>
    </StencilProvider>
  </MbmProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
